import React from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay'
import { useParams } from 'react-router-dom'

import { UserEventsUpcomingSection } from './UserEventsUpcomingSection'

import { UserEventsUpcomingScreenQuery } from './__generated__/UserEventsUpcomingScreenQuery.graphql'

export const UserEventsUpcomingScreen = () => {
  const params = useParams()

  const data = useLazyLoadQuery<UserEventsUpcomingScreenQuery>(
    graphql`
      query UserEventsUpcomingScreenQuery($id: String!) {
        nodeBySlugId(id: $id) {
          __typename

          ... on User {
            ...UserEventsUpcomingSection_user
          }
        }

        ...UserEventsUpcomingSection_query
      }
    `,
    { id: params.actorId! }
  )

  if (data.nodeBySlugId?.__typename !== 'User') {
    return null
  }

  return <UserEventsUpcomingSection user={data.nodeBySlugId} query={data} />
}

export default UserEventsUpcomingScreen
